import React from "react";
import { Link, useParams } from "react-router-dom";
import { Check, Sparkles } from "lucide-react";

export default function OrderSuccess() {
    const { orderId } = useParams();
    return (
        <div className="px-6 md:px-12 lg:px-20 pt-40 pb-20 text-center" data-testid="order-success-page">
            <div className="max-w-xl mx-auto">
                <div className="w-20 h-20 rounded-full bg-blush flex items-center justify-center mx-auto">
                    <Check strokeWidth={1.5} className="w-10 h-10 text-rose" />
                </div>
                <p className="overline mt-8">Pedido confirmado</p>
                <h1 className="font-serif text-5xl text-charcoal mt-3">
                    Gracias por <span className="italic">elegirnos.</span>
                </h1>
                <p className="text-taupe mt-6 leading-relaxed">
                    Hemos recibido tu pedido y muy pronto nos pondremos en contacto contigo
                    para coordinar el pago y el envío. Tu joya está siendo preparada con
                    cariño.
                </p>
                {orderId && (
                    <p className="mt-6 text-sm">
                        <span className="text-taupe">Número de pedido:</span>{" "}
                        <span className="font-mono text-charcoal" data-testid="order-id">
                            {orderId.slice(0, 8).toUpperCase()}
                        </span>
                    </p>
                )}
                <div className="mt-10 flex justify-center gap-3 flex-wrap">
                    <Link
                        to="/catalogo"
                        className="bg-rose text-white hover:bg-rose-dark rounded-full px-8 py-3.5 transition-colors text-xs tracking-[0.2em] uppercase"
                        data-testid="continue-shopping-btn"
                    >
                        Seguir comprando
                    </Link>
                    <Link
                        to="/"
                        className="border border-rose text-rose hover:bg-blush rounded-full px-8 py-3.5 transition-colors text-xs tracking-[0.2em] uppercase"
                    >
                        Ir al inicio
                    </Link>
                </div>
                <Sparkles strokeWidth={1.5} className="w-6 h-6 text-rose mx-auto mt-10" />
            </div>
        </div>
    );
}
